import React from "react";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { CircularProgress, styled } from "@mui/material";

import { D3Chart } from "@giscon/ui.d3chart";
import SimpleTable from "../Faktenblatt";

const StyledTab = styled(Box)({ padding: 3, paddingTop: 0 });

/**
 * Dumb renderer for the time overview Tabs + panels.
 * Renders main and AES (change-to-1971-2000) sections under the same rules
 * as the legacy widget.
 */

const TabHeader = ({ text }) => {
  if (!text) return null;

  return (
    <Typography
      variant="subtitle1"
      style={{ fontWeight: "bold", marginTop: 8, maxWidth: "100%" }}
      title={text}
    >
      {text}
    </Typography>
  );
};

const TimeOverviewTabs = ({
  nls,
  tab,
  onTabChange,
  loading,
  error,
  tabHeaderText,
  tableNls,
  mainTableResult,
  aesTableResult,
  chart,
  aesChart,
}) => {
  return (
    <>
      <Box
        sx={{
          marginTop: "10px",
          marginBottom: 0,
          borderBottom: "1px",
          borderColor: "divider",
        }}
      >
        {error && <Typography>{nls?.error}</Typography>}
        {loading && <CircularProgress data-cy="stats-loading" />}
        {!error && !loading && (
          <Tabs
            value={tab}
            onChange={(event, nextTab) => {
              onTabChange?.(nextTab);
            }}
            centered={true}
            indicatorColor="primary"
          >
            <Tab
              data-cy="tab-table"
              label={nls?.timespanTable}
              sx={(theme) => ({
                backgroundColor:
                  tab === 0 ? theme.palette.brand?.blue : "lightgray",
              })}
              style={{
                border: "1px solid rgb(255, 255, 255)",
                color: tab === 0 ? "white" : "black",
                fontWeight: tab === 0 ? "bold" : "normal",
                minWidth: "80px",
                flex: 1,
              }}
            />
            <Tab
              data-cy="tab-chart"
              label={nls?.timespanChart}
              sx={(theme) => ({
                backgroundColor:
                  tab === 1 ? theme.palette.brand?.blue : "lightgray",
              })}
              style={{
                border: "1px solid rgb(255, 255, 255)",
                color: tab === 1 ? "white" : "black",
                fontWeight: tab === 1 ? "bold" : "normal",
                minWidth: "80px",
                flex: 1,
              }}
            />
          </Tabs>
        )}
      </Box>

      {!error && !loading && tab === 0 && (
        <StyledTab data-cy="stats-table">
          <TabHeader text={tabHeaderText} />
          {mainTableResult && mainTableResult.length > 0 && (
            <SimpleTable
              tableResult={mainTableResult}
              nls={tableNls}
              useNewLayout={true}
            />
          )}

          {aesTableResult && aesTableResult.length > 0 && (
            <div style={{ marginTop: 22 }}>
              <Typography style={{ fontWeight: "bold" }}>
                Änderung zu 1971-2000
              </Typography>
              <SimpleTable
                rawData={null}
                tableResult={aesTableResult}
                nls={tableNls}
                useNewLayout={true}
              />
            </div>
          )}
        </StyledTab>
      )}

      {!error && !loading && tab === 1 && (
        <StyledTab data-cy="stats-chart">
          <TabHeader text={tabHeaderText} />
          {chart && (
            <div className="statistics-chart">
              <D3Chart style={{ marginTop: 15 }} chart={chart} />
            </div>
          )}

          {aesChart && (
            <div style={{ marginTop: 22 }} className="statistics-chart-aes">
              <Typography style={{ fontWeight: "bold" }}>
                Änderung zu 1971-2000
              </Typography>
              <D3Chart style={{ marginTop: 15 }} chart={aesChart} />
            </div>
          )}
        </StyledTab>
      )}
    </>
  );
};

export default TimeOverviewTabs;
